import styled from '@emotion/styled';

export const MarketNameWrapper = styled('div', { label: 'MarketNameWrapper' })`
    display: flex;
    align-items: center;
`;

export const EachWay = styled('div', { label: 'EachWay' })`
    margin-left: 10px;
    font-size: 10px;
`;
